export type FloatingSurface = "floating" | "card" | "background"

const floatingSurfaceTheme: Record<FloatingSurface, string | undefined> = {
  floating: undefined,
  card:
    "[--popover:var(--card-inner)] [--popover-foreground:var(--card-foreground)]",
  background:
    "[--popover:var(--background)] [--popover-foreground:var(--foreground)]",
}

export function getFloatingSurfaceTheme(surface: FloatingSurface) {
  return floatingSurfaceTheme[surface]
}
